import React from 'react';
import '../App.css';

const advantages = [
  {
    icon: '🛠️',
    title: '深度本地化，流程全自动',
    desc: '根据不同疾病、不同地区、机构的服务规范，灵活定制全自动的健康管理与随访工作流，实现精准、高效、合规的自动化管理。',
  },
  {
    icon: '📑',
    title: '多租户架构，无限拓展',
    desc: '支持集团医院、医联体等多中心模式。数据物理隔离、权限独立，总部可统一管理，适应复杂的组织结构与灵活的随访队列、人群管理需求。',
  },
  {
    icon: '📷',
    title: '多模态数据，智能整合',
    desc: '支持病历文本、医学影像、可穿戴设备数据等多模态信息的结构化存储与分析，为临床诊断、AI建模提供高质量数据基础。',
  },
  {
    icon: '🤝',
    title: '多方协作，生态共赢',
    desc: '构建连接医院、患者、社区、科研机构和第三方服务的协作网络，实现信息互通、资源共享、服务联动，共同服务患者健康需求。',
  },
  {
    icon: '🧩',
    title: '模块化设计，快速部署',
    desc: '支持按需选配不同的功能模块，快速搭建业务流程、降低部署与运维成本。',
  },
  {
    icon: '📊',
    title: '人机协作，服务过程可见',
    desc: '实现服务节点追踪与AI副驾驶视角同步，保障服务流程透明管控与持续优化。',
  },
];

function SolutionAdvantages() {
  return (
    <section id="advantages">
      <h2>为什么选择我们？</h2>
      <div style={{textAlign: 'center', color: '#666', fontSize: '1.08rem', marginBottom: 36, maxWidth: 1100, marginLeft: 'auto', marginRight: 'auto'}}>
        六大核心能力，重构医疗服务新范式
      </div>
      <div className="cards-row">
        {advantages.map((a, i) => (
          <div className="card" key={i}>
            <div style={{background: '#003300', borderRadius: '50%', width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px auto', fontSize: 34, color: '#fff', boxShadow: '0 2px 8px rgba(0,51,0,0.10)'}}>
              {a.icon}
            </div>
            <div className="card-title" style={{fontWeight: 700, fontSize: '1.13rem', marginBottom: 10}}>{a.title}</div>
            <div className="card-desc">{a.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default SolutionAdvantages; 